export const FieldError = ({ message, testId }) =>
  message ? (
    <p className="text-sm text-red-400 mt-1.5" role="alert" data-testid={testId}>
      {message}
    </p>
  ) : null;
